import { render } from "./InputBox.vue?vue&type=template&id=4887ed9d&scoped=true&lang=pug"
import script from "./InputBox.vue?vue&type=script&lang=js"
export * from "./InputBox.vue?vue&type=script&lang=js"

import "./InputBox.vue?vue&type=style&index=0&id=4887ed9d&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4887ed9d"]])

export default __exports__